import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MY_FORMATS } from 'src/app/_models/moment-formats';

@Component({
  selector: 'app-autorizacion-presencial-crear',
  standalone: false,
  templateUrl: './autorizacion-presencial-crear.component.html',
  styleUrls: ['./autorizacion-presencial-crear.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})
export class AutorizacionPresencialCrearComponent implements OnInit {

  alumno;

  onSaveSubject = new Subject<string>();
  onSave$ = this.onSaveSubject.asObservable();

  fechaForm = new UntypedFormControl('', Validators.required);

  constructor(public dialogRef: MatDialogRef<AutorizacionPresencialCrearComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.alumno = this.data.alumno;
  }

  submit() {
    if (this.fechaForm.valid) {
      this.onSaveSubject.next(this.fechaForm.value);
    } else {
      this.fechaForm.markAllAsTouched();
    }
  }
}
